<template>
    <div>
        <swb-query-sort-area ref="query_model" :config="queryConfig" :queryHandler="queryHandler"></swb-query-sort-area>
        <div class="simple-row">
            <div class="left">
                <div class="swb-btn swb-btn-small" @click="updateImg">上传</div>
            </div>
        </div>
        <ul class="file-area input clearfix" v-if="imgList.length > 0">
            <li class="file-content clearfix" :class="{'active': ids.indexOf(img.id) != -1}" v-for="(img, index) in imgList" style="height: 100%">
                <swb-file-item :trackKey="index" :fileName="img.dispName" :fileUuid="img.fileUuid" :fileBrowseUrl="img.fileBrowseUrl" :fileDownloadUrl="img.fileDownLoadUrl" :fileMd5="img.fileMd5"
                               :deletable="img.updateFlag" :onDelete="deleteFile"></swb-file-item>
                <el-input :title="img.fileName" :disabled="true" v-model="img.fileName"></el-input>
                <div class="mt5">
                    <a class="swb-btn swb-btn-link" @click="enditImg(img.id)" v-if="img.updateFlag">编辑</a>
                </div>
            </li>
        </ul>
        <div class="pagination-layout">
            <el-pagination background :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange"
                           layout="prev, pager, next, jumper, sizes, total"></el-pagination>
        </div>
    </div>
</template>
<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox, Routes, getComnMerchantAttTag} from '../../app.vues'
    import {getDefaultPageSizes} from '../../app.conf'
    //
    import goodsOrderApi from '../../api/goodsOrder';
    //
    import SwbFileUpload from '../ctrl/FileUpload';
    Vue.regist(SwbFileUpload);
    import SwbFileItem from '../ctrl/FileItem';
    Vue.regist(SwbFileItem);
    import SwbGoodsOrderImgSave from './GoodsOrderImgSave'
    Vue.regist(SwbGoodsOrderImgSave);
    import SwbGoodsOrderImgUpdate from './GoodsOrderImgUpdate'
    Vue.regist(SwbGoodsOrderImgUpdate);
    let searchConfigData = {
        "queryFields": [
            {
                "type": "Text",
                "label": "文件名称",
                "code": "fileName",
                "basic": true,
                "valueType": "String"
            }
        ]
    };
    export default {
        name: 'swb-goods-order-img-list',
        desc: '订单附件管理',
        props: ['id'],
        data: function () {

            return {
                // 资产图片
                imgList: [],
                index: null,
                indexList: [],
                tagName: null,
                //
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //排序、搜索
                queryConfig: searchConfigData,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                ids: [],
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.getDataList();
        },
        methods: {
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.getDataList();
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                let self = this;
                this.pageNumber = val;
                this.getDataList();
            },
            getDataList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.orderId = self.id;
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                goodsOrderApi.getGoodsOrderApdxFileList(postData, function (result) {
                    if (result.type == "info") {
                        let imgList = result.data.rows || [];
                        self.imgList = Utils.merge([], imgList);
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            deleteFile: function (index) {
                let self = this;
                this.$confirm('确定无需继续发货吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let imgList = self.imgList;
                    let img = imgList[index.trackKey];
                    let postData = {
                        id: img.id
                    };
                    let loading = MsgBox.loading();
                    goodsOrderApi.deleteGoodsOrderApdxFile(postData, function (result) {
                        loading.close();
                        if (result.type == "info") {
                            MsgBox.success("刪除成功");
                            self.getDataList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {

                });
                return false;
            },
            enditImg: function (id) {
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: '附件 - 编辑',
                    width: 600,
                    height: 450,
                    template: '<div class = "">' +
                    '<swb-goods-order-img-update :id="id" ref="swb_servc_voucher_img_update"></swb-goods-order-img-update>' +
                    '</div>',
                    data: {
                        id: id
                    },
                    okClicked: function () {
                        let resultData = this.$refs.swb_servc_voucher_img_update.getDlgResult() || {};
                        if (resultData.type === 'info') {
                            let postData = resultData.data;
                            postData.id = id;
                            let loading = MsgBox.loading();
                            goodsOrderApi.updateGoodsOrderApdxFile(postData, function (result) {
                                loading.close();
                                if (result.type == "info") {
                                    MsgBox.success("修改成功");
                                    self.getDataList();
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            })
                        } else {
                            MsgBox.warning(resultData.message);
                            return false;
                        }
                    }
                });
            },
            updateImg: function () {
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: '附件上传',
                    width: 800,
                    height: 650,
                    template: '<div class = "">' +
                    '<swb-goods-order-img-edit :count="count" ref="swb_servc_voucher_img_edit"></swb-goods-order-img-edit>' +
                    '</div>',
                    data: {
                        count: self.totalCount
                    },
                    okClicked: function () {
                        let resultData = this.$refs.swb_servc_voucher_img_edit.getDlgResult() || {};
                        if (resultData.type === 'info') {
                            let postData = {};
                            postData.id = self.id;
                            postData.fileList = resultData.data;
                            let loading = MsgBox.loading();
                            goodsOrderApi.saveGoodsOrderApdxFile(postData, function (result) {
                                loading.close();
                                if (result.type == "info") {
                                    MsgBox.success("保存成功");
                                    self.getDataList();
                                } else {
                                    MsgBox.warning(result.message);
                                }
                            })
                        } else {
                            MsgBox.warning(resultData.message);
                            return false;
                        }
                    }
                });
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/order/GoodsOrderImgList.vue